import { Link } from "react-router-dom";

const ActionButton = ({ to, state, text, isOutlined }) => {
    return (
        <button
            className={`w-fit rounded-lg border-2 border-brand-400 px-3 py-1 text-sm font-bold uppercase  ${
                !isOutlined
                    ? "bg-brand-400  text-white"
                    : "bg-white text-brand-500"
            }`}
        >
            <Link to={to} state={state}>
                {text}
            </Link>
        </button>
    );
};

export default ActionButton;
